// extracted by mini-css-extract-plugin
module.exports =  {"title":"_7a3fb80146--title--thYIU","promo":"_7a3fb80146--promo--DPEh2","last-updated":"_7a3fb80146--last-updated--nl717"};